import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function PageHeader({
  title,
  backTo = -1, // default: go back in history
  stateToPass = null,
}) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (typeof backTo === "string") {
      navigate(backTo, stateToPass ? { state: stateToPass } : undefined);
    } else {
      navigate(backTo);
    }
  };

  return (
    <div className="mb-6 relative flex items-center pt-8">
      {/* Back Button */}
      <button
        onClick={handleBack}
        className="absolute left-2 flex items-center gap-2 text-gray-600 hover:text-gray-900"
      >
        <FaArrowLeft />
        <span className="hidden sm:inline">Back</span>
      </button>

      {/* Title */}
      <h1 className="mx-auto text-3xl sm:text-2xl flex items-center gap-2 truncate">
        {title}
      </h1>
    </div>
  );
}
